// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { SAMLAuthProvider, getAuth } from "firebase/auth";

const provider = new SAMLAuthProvider(import.meta.env.VITE_FIREBASE_AUTH_PROVIDER);

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
auth.tenantId = import.meta.env.VITE_FIREBASE_TENANT_ID;

export { app, provider, auth }
